import { render, staticRenderFns } from "./Chapter8_1.vue?vue&type=template&id=5932f98c&scoped=true&"
import script from "./Chapter8_1.vue?vue&type=script&lang=js&"
export * from "./Chapter8_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932f98c",
  null
  
)

export default component.exports